import Background from 'components/Background'
import BannerHome from 'components/BannerHome'
import Card from 'components/Card'
import Header from 'components/Header'

import imagePopulatioZero from 'assets/img/games/population-zero.png'
import imageProjectWinter from 'assets/img/games/project-winter.png'
import imageBorderlands3 from 'assets/img/games/borderlands-3.png'

import * as S from './styles'

const Home = () => {
  return (
    <S.Wrapper>
      <Background />
      <Header />
      <BannerHome />
      <S.Title>
        <h1>News</h1>
      </S.Title>
      <S.WrapperCards>
        <Card
          title="Population Zero"
          publisher="Other Ocean"
          image={imagePopulatioZero}
          price="$ 215,00"
        />
        <Card
          title="Project Winter"
          publisher="Rockstar Games"
          image={imageProjectWinter}
          price="$ 215,00"
        />
        <Card
          title="Borderlands 3"
          publisher="Rockstar Games"
          image={imageBorderlands3}
          price="$ 175,00"
        />
      </S.WrapperCards>
    </S.Wrapper>
  )
}

export default Home
